//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SiloRouterV2
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x8658047e48CC09161f4152c79155Dac1d710Ff0a)
 */
export const siloRouterV2Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_wrappedNativeToken', internalType: 'address', type: 'address' },
      { name: '_siloRepository', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'ApprovalFailed' },
  { type: 'error', inputs: [], name: 'ERC20TransferFailed' },
  { type: 'error', inputs: [], name: 'EthTransferFailed' },
  { type: 'error', inputs: [], name: 'InvalidSilo' },
  { type: 'error', inputs: [], name: 'InvalidSiloRepository' },
  { type: 'error', inputs: [], name: 'TokenIsNotAContract' },
  { type: 'error', inputs: [], name: 'UnsupportedAction' },
  {
    type: 'function',
    inputs: [
      {
        name: '_actions',
        internalType: 'struct SiloRouterV2.Action[]',
        type: 'tuple[]',
        components: [
          {
            name: 'actionType',
            internalType: 'enum SiloRouterV2.ActionType',
            type: 'uint8',
          },
          { name: 'silo', internalType: 'contract ISilo', type: 'address' },
          { name: 'asset', internalType: 'contract IERC20', type: 'address' },
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
          { name: 'collateralOnly', internalType: 'bool', type: 'bool' },
        ],
      },
    ],
    name: 'execute',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloRepository',
    outputs: [
      { name: '', internalType: 'contract ISiloRepository', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloRouterPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'wrappedNativeToken',
    outputs: [
      {
        name: '',
        internalType: 'contract IWrappedNativeToken',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x8658047e48CC09161f4152c79155Dac1d710Ff0a)
 */
export const siloRouterV2Address = {
  1: '0x8658047e48CC09161f4152c79155Dac1d710Ff0a',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x8658047e48CC09161f4152c79155Dac1d710Ff0a)
 */
export const siloRouterV2Config = {
  address: siloRouterV2Address,
  abi: siloRouterV2Abi,
} as const
